import axios from "axios";
import { API_URL, CLIENT_TOKEN, ACCESS_TOKEN_KEY, JWT_EXPIRED_MESSAGE } from "../constants";



const Api = axios.create({
  baseURL: API_URL + CLIENT_TOKEN,
  responseType: "json",
  withCredentials: false //  TODO change
 });

Api.interceptors.response.use(
  function(response) {
    // If the request succeeds, we don't have to do anything and just return the response
    console.log("response from interceptor", response);
    return response;
  },
  function(error) {
    const errorResponse = error.response.data;
    console.log("error from interceptor", errorResponse);
    if (isTokenExpiredError(errorResponse)) {
      return resetTokenAndReattemptRequest(error);
    }
    // If the error is due to other reasons, we just throw it back to axios
    return Promise.reject(error);
  }
);
export function isTokenExpiredError(errorResponse) {
  if (
    errorResponse.code === 401 &&
    errorResponse.message === JWT_EXPIRED_MESSAGE
  ) {
    console.log("Jwt Expired");
    return true;
  }
  return false;
}

let isAlreadyFetchingAccessToken = false;

// This is the list of waiting requests that will retry after the JWT refresh complete
export let subscribers = [];

export async function resetTokenAndReattemptRequest(error) {
  // try {
  //   const { response: errorResponse } = error;
  //   console.log(error);
  //   const resetToken = await localStorage.getItem(REFRESH_TOKEN_KEY);
  //   // const resetToken = "resetToken";
  //   if (!resetToken) {
  //     // We can't refresh, throw the error anyway
  //     console.log("We can't refresh");
  //     return Promise.reject(error);
  //   }
  //   console.log("token from storage ", resetToken);
  //   /* Proceed to the token refresh procedure
  //   We create a new Promise that will retry the request,
  //   clone all the request configuration from the failed
  //   request in the error object. */
  //   const retryOriginalRequest = new Promise(resolve => {
  //     /* We need to add the request retry to the queue
  //     since there another request that already attempt to
  //     refresh the token */
  //     addSubscriber((access_token) => {
  //       errorResponse.config.headers.Authorization = "Bearer " + access_token;
  //       resolve(Api(errorResponse.config));
  //     });
  //   });
  //   console.log("going here ", retryOriginalRequest);
  //   if (!isAlreadyFetchingAccessToken) {
  //     isAlreadyFetchingAccessToken = true;

  //     const response = await Api.post(REFRESHTOKEN_ENDPOINT, {
  //       refreshToken: resetToken // Just an example, your case may vary
  //     });

  //     if (!response.data) {
  //       return Promise.reject(error);
  //     }
  //     const newToken = response.data.accessToken;
  //     await localStorage.setItem(ACCESS_TOKEN_KEY, newToken);
  //     isAlreadyFetchingAccessToken = false;
  //     onAccessTokenFetched(newToken);
  //   }
  //   return retryOriginalRequest;
  // } catch (err) {
  //   console.log("errr", err);
  //   return Promise.reject(err);
  // }
}

export function onAccessTokenFetched(accessToken) {
  // When the refresh is successful, we start retrying the requests one by one and empty the queue
  subscribers.forEach(callback => callback(accessToken));
  subscribers = [];
  console.log("object", subscribers);
}

export function addSubscriber(callback) {
  subscribers.push(callback);
}

// Automatically adds the bearer token when the user has one
Api.interceptors.request.use(
  async config => {
    if (config.baseURL === API_URL + CLIENT_TOKEN && !config.headers.Authorization) {
      const token = await localStorage.getItem(ACCESS_TOKEN_KEY);

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    return config;
  },
  error => Promise.reject(error)
);

export default Api;
